import axiosInstance from '../utils/axios';

export const getSplashData = async () => {
    try {
        const response = await axiosInstance.get('/splash');
        return response.data;
    } catch (error) {
        throw error;
    }
}; 